import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import api from "@/api";
// import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import { Link } from "react-router-dom";
import { useLayoutEffect } from "react";
const OldSubmit = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const emailFromQuery = query.get("email");
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [email, setEmail] = useState(emailFromQuery || "");
  const navigate = useNavigate();
  const [userIdeas, setUserIdeas] = useState([]);
  const [selectedIdeas, setSelectedIdeas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [submittedIdeas, setSubmittedIdeas] = useState([]);

  //   useEffect(() => {
  //     if (emailFromQuery) {
  //       fetchUserIdeas();
  //     } else {
  //       setError("No email found in URL.");
  //       setLoading(false);
  //     }
  //   }, [emailFromQuery]);
  useEffect(() => {
    let resolvedEmail = emailFromQuery;

    if (!resolvedEmail) {
      const currentUser = localStorage.getItem("currentUser");
      if (currentUser) {
        try {
          const user = JSON.parse(currentUser);
          resolvedEmail = user?.email || "";
        } catch (err) {
          console.error("Invalid currentUser in localStorage", err);
        }
      }
    }

    if (resolvedEmail) {
      setEmail(resolvedEmail);
      fetchUserIdeas(resolvedEmail);
    } else {
      setError("No email found in URL or local storage.");
      setLoading(false);
    }
  }, [emailFromQuery]);

  // const [searchParams] = useSearchParams();

  // useEffect(() => {
  //   const type = searchParams.get("type");
  //   if (type === "new") {
  //     setSubmissionType("new");
  //   }
  // }, []);

  const fetchUserIdeas = async (userEmail) => {
    setLoading(true);
    setError("");

    try {
      const token = localStorage.getItem("token");

      const response = await api.get("/ideas/my-ideas", {
        headers: { Authorization: `Bearer ${token}` },
        params: { email: userEmail }, // safe to pass
      });

      const oldIdeas = response.data?.oldIdeas || [];
      const currentIdeas = response.data?.currentIdeas || [];

      if (oldIdeas.length === 0 && currentIdeas.length === 0) {
        setUserIdeas([]);
      } else {
        const formatted = oldIdeas.map((idea) => ({
          useCaseId: idea.uc_id,
          submittedBy: idea.name,
          email: idea.email,
          title: idea.uc_title,
        }));
        setUserIdeas(formatted);
      }
    } catch (err) {
      console.error(err);
      setUserIdeas([]);
    } finally {
      setLoading(false);
    }
  };

  const toggleIdeaSelection = (id) => {
    setSelectedIdeas((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleStartNowClick = () => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate(
        `/login?email=${encodeURIComponent(
          email || ""
        )}&redirect=submit-idea&type=new`
      );
      return;
    }

    // Add type=new parameter
    navigate(
      `/submit-idea?email=${encodeURIComponent(
        email || ""
      )}&redirect=submit-idea&type=new`
    );
  };

  const requestSheets = async () => {
    if (selectedIdeas.length === 0) {
      toast.error("Select at least one idea first!", { duration: 3000 });
      return;
    }

    try {
      const token = localStorage.getItem("token");

      const response = await api.post(
        "/uc1-requests/request-submission-sheet",
        { ideaIds: selectedIdeas },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        // Save submitted ideas for modal
        const ideasToShow = userIdeas.filter((idea) =>
          selectedIdeas.includes(idea.useCaseId)
        );
        setSubmittedIdeas(ideasToShow);

        // Clear selected ideas
        setSelectedIdeas([]);

        // Show modal
        setShowModal(true);
      } else {
        if (response.data.errors && response.data.errors.length > 0) {
          response.data.errors.forEach((errMsg) => {
            toast.error(errMsg, { duration: 4000 });
          });
        } else {
          toast.error(response.data.message || "Request failed.", {
            duration: 4000,
          });
        }
      }
    } catch (err) {
      console.error(err);
      const apiMessage =
        err.response?.data?.errors?.[0] ||
        err.response?.data?.message ||
        "Request failed. Please try again.";

      toast.error(apiMessage, { duration: 4000 });
    }
  };

  if (loading)
    return (
      <p className="text-white text-center text-xl mt-20 animate-pulse">
        Fetching your ideas...
      </p>
    );

  return (
    <div className="min-h-screen bg-[#0b0e12] text-white py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold text-center mb-6 text-gray-100 tracking-wide">
          Udbhav 1.0 Submitted Ideas
        </h1>

        <p className="text-center text-gray-400 mb-8 text-sm">
          Showing ideas you submitted during Udbhav 1.0 :{" "}
          <span className="font-semibold text-gray-200">{email}</span>
        </p>

        {error && (
          <p className="text-red-400 text-center mb-4 text-sm">{error}</p>
        )}

        <div className=" rounded-xl shadow-md p-5">
          {userIdeas.length === 0 ? (
            <div className="flex justify-center mt-16">
              <div className=" p-8 w-full max-w-lg text-center">
                <div className="text-4xl mb-3">⚠️</div>

                <h2 className="text-lg font-semibold text-gray-100 mb-2">
                  No Udbhav 1.0 submissions found for this email.
                </h2>

                <p className="text-gray-400 text-sm leading-relaxed">
                  Please enter the same email ID used while submitting your idea
                  in Udbhav 1.0. If you need help finding the Excel template you
                  uploaded, please email us at
                  <span className="text-emerald-400 font-medium">
                    {" "}
                    aastha.jain@oges.co
                  </span>{" "}
                  with either your Use Case Number or the email ID used during
                  submission.
                </p>

                {/* <div className="inline-block bg-gray-700 text-gray-100 font-medium px-3 py-1 rounded-full text-sm animate-blink" >
   <button onClick={handleStartNowClick}>Start Now</button>
   
</div> */}
              </div>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full text-sm table-fixed">
                <thead className="bg-gray-800/60 text-gray-300 border-b border-gray-700">
                  <tr>
                    <th className="p-3 text-left font-normal w-20">Select</th>
                    <th className="p-3 text-left font-normal w-32">
                      Use Case ID
                    </th>
                    <th className="p-3 text-left font-normal w-40">
                      Submitted By
                    </th>
                    <th className="p-3 text-left font-normal w-48">Email</th>
                    <th className="p-3 text-left font-normal w-[400px]">
                      Title
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {userIdeas.map((idea) => (
                    <tr
                      key={idea.useCaseId}
                      className="border-t border-gray-700/40 hover:bg-gray-800/40 transition-colors"
                    >
                      <td className="p-3 w-20">
                        <input
                          type="checkbox"
                          className="h-4 w-4 accent-blue-500 cursor-pointer"
                          checked={selectedIdeas.includes(idea.useCaseId)}
                          onChange={() => toggleIdeaSelection(idea.useCaseId)}
                        />
                      </td>

                      <td className="p-3 text-gray-200 w-32">
                        {idea.useCaseId}
                      </td>
                      <td className="p-3 text-gray-300 w-40">
                        {idea.submittedBy}
                      </td>
                      <td className="p-3 text-gray-400 w-48">{idea.email}</td>
                      <td className="p-3 text-gray-300 w-[400px]">
                        {idea.title}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {userIdeas.length > 0 && (
          <div className="flex justify-end mt-6">
            <Button
              disabled={selectedIdeas.length === 0}
              onClick={requestSheets}
              className="bg-blue-600 hover:bg-blue-700 px-6 py-2 rounded-lg shadow-lg transition-all flex items-center text-white font-medium"
            >
              Send Request for Submission Sheet
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        )}

        {/* Modal */}
        {showModal && (
<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
  <div className="bg-gray-900 rounded-2xl shadow-2xl p-6 sm:p-8 max-w-md w-full text-white">

    {/* Title */}
    <h2 className="text-xl sm:text-2xl font-semibold text-center
                   bg-gradient-to-r from-green-400 via-red-400 to-green-400
                   bg-clip-text text-transparent mb-4">
      Request Sent Successfully
    </h2>

    {/* Submitted ideas */}
    <div className="mb-4 max-h-48 overflow-y-auto rounded-lg border border-gray-700">
      <ul className="divide-y divide-gray-700">
        {submittedIdeas.map((idea) => (
          <li key={idea.useCaseId} className="p-3">
            <p className="text-sm font-medium">{idea.title}</p>
          </li>
        ))}
      </ul>
    </div>

    {/* Info message */}
    <p className="text-xs sm:text-sm text-gray-300 text-center leading-relaxed mb-6">
      We have received your request for the detailed use case excel submitted during
      Udbhav&nbsp;1. Our team will share the details with you via email within the
      next&nbsp;4 working hours.
    </p>

    {/* Action */}
    <div className="flex justify-center">
      <Button
        onClick={() => setShowModal(false)}
        className="bg-blue-600 hover:bg-blue-700 px-8 py-2 rounded-xl shadow-lg"
      >
        Close
      </Button>
    </div>

  </div>
</div>

        )}
      </div>
    </div>
  );
};

export default OldSubmit;










